import ActionButtons from "../shared/ActionButtons";
import ApplicationInfo from "./ApplicationInfo";
import ContestInfo from "./ContestInfo";
import DeleteApplicationDialog from "./DeleteApplicationDialog";
import React from "react";
import { ApplicationStatus } from "../../interfaces/enums";
import { ApplicationWithId } from "../../interfaces/IApplications";
import { ContestWithId } from "../../interfaces/IContests";
import { Grid, ListItem } from "@mui/material";
import { useRegistrationValidation } from "../../hooks/useRegistrationValidation";

// Główny komponent ContestListItem
interface ContestListItemProps {
  contest: ContestWithId;
  application?: ApplicationWithId;
  onAddApplication: (contest: ContestWithId) => void;
  onEditApplication: (contestId: string, applicationId: string) => void;
  onRemoveApplication: (applicationId: string) => void;
}

export default function ContestListItem({
  contest,
  application,
  onAddApplication,
  onEditApplication,
  onRemoveApplication,
}: ContestListItemProps) {
  const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
  const registrationStatus = useRegistrationValidation(contest);

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    onRemoveApplication(application!.id!);
    setDeleteDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <>
      <ListItem
        sx={{
          py: 2,
          px: { xs: 2, sm: 3 },
          "&:hover": {
            backgroundColor: "#f9f9f9",
          },
        }}
      >
        <Grid container spacing={2} sx={{ width: "100%" }}>
          {/* Kolumna 1: Dane o turnieju */}
          <Grid item xs={12} md={5}>
            <ContestInfo contest={contest} />
          </Grid>

          {/* Kolumna 2: Dane zgłoszenia */}
          <Grid item xs={12} md={4}>
            <ApplicationInfo application={application} />
          </Grid>

          {/* Kolumna 3: Akcje */}
          <Grid item xs={12} md={3}>
            <ActionButtons
              hasApplication={!!application}
              onAdd={() => onAddApplication(contest)}
              onEdit={() => onEditApplication(contest.id!, application!.id!)}
              onDelete={handleDeleteClick}
              applicationStatus={application?.status}
              disabled={!registrationStatus.canRegister}
              disabledReason={registrationStatus.reason}
              hideWhenDisabled={true}
            />
          </Grid>
        </Grid>
      </ListItem>

      {/* Dialog potwierdzenia usunięcia */}
      <DeleteApplicationDialog
        open={deleteDialogOpen}
        contestName={contest.name}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
      />
    </>
  );
}
